<template>
    <div class="page-wrapper vh-center-content full-height">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "Page"
    };
</script>

<style></style>
